/* eslint-disable import/no-cycle */
import { useContext } from 'react';

import type { DataModelStableContextValue } from 'contexts/datamodel/DataModelContext.core';
import {
  Container,
  DataModelContext,
  DataModelStableContext,
  IDataModelContext
} from 'contexts/datamodel/DataModelContext.core';

export const useDataModelContext = <T extends Container>() => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const dataModelState = useContext<IDataModelContext<T>>(DataModelContext);
  return dataModelState;
};

// Use this instead of useDataModelContext when the component only needs generateHierarchyId
// or getArticlePromotionLogByOriginId and must not re-render on every root change (e.g. drag end).
export const useDataModelStableContext = (): DataModelStableContextValue => useContext(DataModelStableContext);
